import React from 'react'
import { Table } from '@themesberg/react-bootstrap'
import { getPercentageColor, getTextColor } from '../../utils/dashboardEffects'
import { internationalNumberFormatter } from '../../utils/helpers'
import sortArrowIcon from '../SortArrowsIcon'
import CustomInfiniteScroll from '../CustomInfiniteScroll'

const gameReportTableCommonHeaders = ['Id', 'Name', 'Number of Bets', 'Total Bets', 'Total Wins', 'Game Revenue', 'Payout']

const getTableHeaders = (isPlayer, showAggregator) => {
  if (isPlayer) {
    return gameReportTableCommonHeaders
  } else {
    const response = [...gameReportTableCommonHeaders]
    if (showAggregator) {
      response.splice(2, 0, 'Aggregator')
      response.splice(4, 0, 'Number of Players')
      return response
    }
    response.splice(3, 0, 'Number of Players')
    return response
  }
}

/**
 * @param {function} [fetchMoreData] - Optional function to fetch additional data when the user scrolls near the bottom.
 *   Triggered automatically by the infinite scroll component.
 *
 * @param {boolean} [hasMoreData] - Optional flag indicating whether there is more data available to load.
 *   If false, infinite scrolling stops fetching more data.
 */
const GameReportTable = ({
  tableData,
  isPlayer,
  sortBy,
  setSortBy,
  hover,
  setHover,
  showAggregator = false,
  fetchMoreData,
  hasMoreData
}) => {
  const tableContent = (
    <Table bordered striped responsive hover size='sm' className='text-center mt-4'>
      <thead className='thead-dark'>
        <tr>
          {getTableHeaders(isPlayer, showAggregator).map((h) => (
            <th key={h}>
              {h}
              {!isPlayer && sortArrowIcon(h, sortBy, setSortBy, hover, setHover, 'gameReport')}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {tableData && tableData.length > 0
          ? (
              tableData.map(({ id, name, roundCount, playerCount, totalBet, totalWin, GGR, payout, aggregatorName }) => (
                <tr key={`top-loosers-${id}`}>
                  <td>{id}</td>
                  <td style={{ textAlign: 'start' }}>{name}</td>
                  {showAggregator && <td>{aggregatorName}</td>}
                  <td>{internationalNumberFormatter(roundCount) || '0'}</td>
                  {!isPlayer && <td>{internationalNumberFormatter(playerCount) || '0'}</td>}
                  <td style={{ color: 'green' }}>€ {internationalNumberFormatter(totalBet) || '0'}</td>
                  <td style={{ color: 'red' }}>€ {internationalNumberFormatter(totalWin) || '0'}</td>
                  <td className={getTextColor(GGR)}>€ {internationalNumberFormatter(GGR) || '0'}</td>
                  <td className={getPercentageColor(payout)}>{payout || '0'}</td>
                </tr>
              ))
            )
          : (
            <tr>
              <td colSpan={showAggregator ? (isPlayer ? 6 : 7) : (isPlayer ? 5 : 6)} className='text-danger text-center'>
                No data found
              </td>
            </tr>
            )}
      </tbody>
    </Table>
  )

  if (fetchMoreData && hasMoreData !== undefined) {
    return (
      <CustomInfiniteScroll
        dataLength={tableData?.length || 0}
        next={fetchMoreData}
        hasMore={hasMoreData}
        scrollableTarget='game-report-scroll'
        scrollThreshold={0.9}
      >
        {tableContent}
      </CustomInfiniteScroll>
    )
  }

  return tableContent
}

export default GameReportTable
